const BRANDING_PREFIXES = ['courses', 'tickets', 'subscription'];

export const pathNormalization = (path: string) => {
    const cleanPath = path.startsWith('/') ? path.slice(1) : path;
    const isBranding = cleanPath.includes('branding/');
    
    const prefix = BRANDING_PREFIXES.find(p => cleanPath.startsWith(`${p}/`));
    const normalized = prefix ? cleanPath.replace(`${prefix}/`, '') : cleanPath;

    return {normalized, isBranding};
};